(() => {
  const LOOPS = 8;
  const FALLBACK = ['🍵', '💚', '⭐'];
  const CONFETTI = ['#f7a8bc', '#f0609a', '#ffffff', '#1f6b3a', '#ffe27a'];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Progress lives in the visitor's browser so a reload doesn't reset their spins
  const load = (key) => {
    try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
  };
  const save = (key, data) => {
    try { localStorage.setItem(key, JSON.stringify(data)); } catch (e) { /* storage blocked */ }
  };

  const init = (root) => {
    if (root.dataset.jpReady === 'true') return;
    root.dataset.jpReady = 'true';

    const strips = [...root.querySelectorAll('.jp-strip')];
    const triggers = [...root.querySelectorAll('[data-jp-spin]')];
    const keys = [...root.querySelectorAll('[data-jp-key]')];
    const result = root.querySelector('.jp-result');
    const confetti = root.querySelector('.jp-confetti');
    const leftEl = root.querySelector('[data-jp-left]');
    const copyBtn = root.querySelector('[data-jp-copy]');
    const resetBtn = root.querySelector('[data-jp-reset]');
    const countdownEl = root.querySelector('[data-jp-countdown]');
    const resetSeconds = parseInt(root.dataset.resetSeconds, 10) || 0;

    const tries = parseInt(root.dataset.tries, 10) || 3;
    const winSpin = Math.min(parseInt(root.dataset.winSpin, 10) || 2, tries);
    const storeKey = 'dripJackpot:v2';
    const progress = Object.assign({ registered: false, used: 0, won: false, prize: null }, load(storeKey));

    // Prizes from the section settings; entries without a code are skipped
    let prizes = { common: [], rare: [] };
    try { prizes = JSON.parse(root.querySelector('[data-jp-prizes]').textContent); } catch (e) { /* no prize list */ }
    const common = (prizes.common || []).filter((p) => p.code);
    const rare = (prizes.rare || []).filter((p) => p.code && p.oneIn > 0).sort((a, b) => b.oneIn - a.oneIn);

    // Rarest first: 1 in oneIn each; everyone else gets an equal share of the common prizes
    const choosePrize = () => {
      for (const p of rare) {
        if (Math.random() < 1 / p.oneIn) return { label: p.label, code: p.code, rare: true };
      }
      const p = common[Math.floor(Math.random() * common.length)] || { label: '', code: '' };
      return { label: p.label, code: p.code, rare: false };
    };

    const wonHeading = root.querySelector('[data-jp-won-heading]');
    const codeEl = root.querySelector('[data-jp-code]');
    const ctaEl = root.querySelector('[data-jp-cta]');
    const withPrize = (text, prize) => (text || '').replace(/\[prize\]/g, prize ? prize.label : '');

    const showPrize = (prize) => {
      if (!prize) return;
      if (wonHeading) wonHeading.textContent = withPrize(wonHeading.dataset.template, prize);
      if (codeEl) codeEl.textContent = prize.code;
      if (ctaEl) ctaEl.href = `/discount/${encodeURIComponent(prize.code)}?redirect=${encodeURIComponent(root.dataset.redirect || '/collections/all')}`;
      root.classList.toggle('is-mega', !!prize.rare);
    };

    // Shopify re-renders the page after the form posts; this marker means it succeeded
    if (root.querySelector('[data-jp-registered]')) progress.registered = true;
    const editorPreview = root.hasAttribute('data-editor-unlocked');

    // Shopify's bot protection runs a captcha before the signup is sent and can bring the
    // visitor back without the marker, so remember the signup was sent (for 15 minutes)
    // and trust it unless Shopify shows an error
    const PENDING = 'dripJackpot:pending';
    try {
      const sentAt = parseInt(sessionStorage.getItem(PENDING), 10);
      if (sentAt && Date.now() - sentAt < 15 * 60 * 1000 && !root.querySelector('.jp-form__error')) progress.registered = true;
      sessionStorage.removeItem(PENDING);
    } catch (e) { /* storage blocked */ }

    // Symbols come from hidden images rendered by Liquid; fall back to emoji
    let symbols = [...root.querySelectorAll('.jp-symbols img')].map((img) => {
      const el = document.createElement('div');
      el.className = 'jp-sym';
      const clone = img.cloneNode(true);
      clone.removeAttribute('loading');
      el.appendChild(clone);
      return el;
    });
    if (symbols.length < 2) {
      symbols = symbols.concat(FALLBACK.map((txt) => {
        const el = document.createElement('div');
        el.className = 'jp-sym jp-sym--text';
        el.textContent = txt;
        return el;
      }));
    }
    const count = symbols.length;
    const total = count * LOOPS;

    const positions = strips.map((strip, i) => {
      for (let l = 0; l < LOOPS; l++) {
        symbols.forEach((sym) => strip.appendChild(sym.cloneNode(true)));
      }
      return i % count;
    });

    const place = (strip, index, ms, easing) => {
      strip.style.transition = ms ? `transform ${ms}ms ${easing}` : 'none';
      strip.style.transform = `translateY(${-(index / total) * 100}%)`;
    };

    const render = () => {
      const unlocked = progress.registered || editorPreview;
      let state = 'locked';
      if (progress.won) state = 'won';
      else if (unlocked) state = progress.used >= tries ? 'out' : 'ready';
      root.dataset.state = state;

      const left = Math.max(tries - progress.used, 0);
      if (leftEl) leftEl.textContent = left;
      keys.forEach((key, i) => key.classList.toggle('is-used', i < progress.used));
      triggers.forEach((t) => { t.disabled = state !== 'ready'; });
    };

    // Winners who come back see the line they won, everyone else a mixed line
    if (progress.won) positions.fill(Math.min(progress.winSym || 0, count - 1));
    strips.forEach((strip, i) => place(strip, positions[i], 0));
    render();
    if (progress.won) showPrize(progress.prize);

    if (progress.registered && !editorPreview) save(storeKey, progress);

    const burst = (amount = 70) => {
      if (!confetti || reduceMotion) return;
      confetti.innerHTML = '';
      for (let i = 0; i < amount; i++) {
        const bit = document.createElement('i');
        bit.style.left = `${Math.random() * 100}%`;
        bit.style.background = CONFETTI[i % CONFETTI.length];
        bit.style.setProperty('--x', `${(Math.random() - .5) * 240}px`);
        bit.style.setProperty('--r', `${360 + Math.random() * 720}deg`);
        bit.style.setProperty('--d', `${1.8 + Math.random() * 1.6}s`);
        bit.style.animationDelay = `${Math.random() * .4}s`;
        confetti.appendChild(bit);
      }
      setTimeout(() => { confetti.innerHTML = ''; }, 4200);
    };

    let spinning = false;

    const spin = () => {
      if (spinning || root.dataset.state !== 'ready') return;
      spinning = true;
      progress.used += 1;
      const isWin = progress.used >= winSpin;
      // Decide the prize once and keep it, so a reload can't roll again
      if (isWin && !progress.prize) progress.prize = choosePrize();

      triggers.forEach((t) => { t.disabled = true; });
      root.classList.remove('is-win', 'is-miss', 'is-settling');
      root.classList.add('is-pulling', 'is-spinning');
      if (result) result.textContent = '';

      // Win: three of a kind, never the product the near miss teased.
      // Near miss: the first two match, the last one doesn't.
      const pickOther = (exclude) => {
        const pool = [...Array(count).keys()].filter((n) => !exclude.includes(n));
        return pool[Math.floor(Math.random() * pool.length)];
      };
      let targets;
      if (isWin) {
        const win = pickOther([progress.missSym]);
        progress.winSym = win;
        targets = [win, win, win];
      } else {
        const pair = pickOther([progress.missSym]);
        progress.missSym = pair;
        targets = [pair, pair, pickOther([pair])];
      }
      const durations = strips.map((_, i) => reduceMotion ? 0 : 1600 + i * 450 + (!isWin && i === 2 ? 500 : 0));

      strips.forEach((strip, i) => {
        // Jump back to the same symbol in the first loop, then run to the last loop
        place(strip, positions[i] % count, 0);
        strip.offsetHeight; // force reflow so the jump isn't animated
        positions[i] = (LOOPS - 1) * count + targets[i];
        place(strip, positions[i], durations[i], 'cubic-bezier(.15,.75,.25,1.04)');
      });

      setTimeout(() => root.classList.remove('is-pulling'), 700);
      setTimeout(() => root.classList.add('is-settling'), Math.max(...durations) - 500);

      setTimeout(() => {
        root.classList.remove('is-spinning', 'is-settling');
        if (isWin) {
          progress.won = true;
          root.classList.add('is-win');
          showPrize(progress.prize);
          if (result) result.textContent = withPrize(root.dataset.winText, progress.prize);
          burst(progress.prize && progress.prize.rare ? 160 : 70);
        } else {
          root.classList.add('is-miss');
          if (result) result.textContent = root.dataset.missText || '';
        }
        if (!editorPreview) save(storeKey, progress);
        spinning = false;
        render();
        if (isWin) root.dispatchEvent(new CustomEvent('jackpot:won'));
      }, Math.max(...durations) + 80);
    };

    triggers.forEach((t) => t.addEventListener('click', spin));

    // Signups must go through Shopify's normal submit (it adds the captcha token), so only
    // note the time it was sent; the check above unlocks the machine when the visitor is back
    const form = root.querySelector('form.jp-form');
    form && form.addEventListener('submit', () => {
      try { sessionStorage.setItem(PENDING, String(Date.now())); } catch (e) { /* storage blocked */ }
    });

    let resetTimer = null;

    // Next player: forget this visitor so the email form and 3 fresh spins come back.
    // After a signup Shopify adds ?customer_posted=true, which would unlock the machine
    // again on render, so drop it with a reload; otherwise reset in place.
    const reset = () => {
      clearInterval(resetTimer);
      resetTimer = null;
      try { localStorage.removeItem(storeKey); } catch (e) { /* storage blocked */ }

      const params = new URLSearchParams(window.location.search);
      if (!editorPreview && params.has('customer_posted')) {
        params.delete('customer_posted');
        const query = params.toString();
        window.location.replace(window.location.pathname + (query ? '?' + query : '') + '#' + root.id);
        return;
      }

      Object.assign(progress, { registered: false, used: 0, won: false, prize: null, missSym: undefined, winSym: undefined });
      root.classList.remove('is-win', 'is-miss', 'is-mega');
      if (result) result.textContent = '';
      const email = root.querySelector('input[type="email"]');
      if (email) email.value = '';
      render();
      root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };
    const startResetCountdown = () => {
      if (!resetSeconds || editorPreview || resetTimer) return;
      let left = resetSeconds;
      if (countdownEl) countdownEl.textContent = left;
      resetTimer = setInterval(() => {
        left -= 1;
        if (countdownEl) countdownEl.textContent = Math.max(left, 0);
        if (left <= 0) { clearInterval(resetTimer); reset(); }
      }, 1000);
    };

    resetBtn && resetBtn.addEventListener('click', reset);
    root.addEventListener('jackpot:won', startResetCountdown);
    if (progress.won) startResetCountdown();

    copyBtn && copyBtn.addEventListener('click', async () => {
      const code = progress.prize ? progress.prize.code : '';
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        tmp.remove();
      }
      const label = copyBtn.textContent;
      copyBtn.textContent = copyBtn.dataset.copied || label;
      setTimeout(() => { copyBtn.textContent = label; }, 1800);
    });
  };

  const boot = () => document.querySelectorAll('[data-drip-jackpot]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
